// Reference swatches:
// https://uicolors.app/edit?sv1=gray:50-f6f9f9/100-e6ecef/200-ced9de/300-bcc8cd/400-829197/500-60727b/600-4e626a/700-44535a/800-3b4a51/900-2a3841/950-020303;turquoise:50-edfdfa/100-caf7f0/200-a3f5e7/300-5becd4/400-22ddc4/500-12baa6/600-0b988a/700-0e776c/800-12695d/900-0d4e46/950-052e2c;purple:50-f3f2fd/100-eae5fa/200-cac2fa/300-b2a7fb/400-8480fa/500-6653f3/600-5b45e8/700-5037cd/800-4d3bb5/900-3a2b82/950-241a4c;blue:50-f0f4ff/100-dbe6ff/200-c0d3fc/300-9ebefa/400-5f8ff7/500-3d7df5/600-256df4/700-1563e0/800-1756b5/900-194a8f/950-00295c
module.exports = {
  transparent: 'transparent',
  midnightblue: {
    'primary': '#012C76',
    '500': '#012C76',
    '600': '#011F53',
    DEFAULT: '#012C76',
  },
  blue: {
    50: 'hsl(222, 100%, 97%)', // brand approx hex #f2f6ff
    100: 'hsl(222, 100%, 93%)', // brand #E5EDFE, revised to be more similar hue
    // 150: 'hsl(219, 90%, 92%)', // brand #D7E4FD
    200: 'hsl(221, 91%, 87%)',
    300: 'hsl(219, 90%, 80%)', // brand #9ebefa
    400: 'hsl(219, 90%, 67%)',
    500: 'hsl(219, 90%, 60%)',
    600: 'hsl(219, 90%, 55%)', // default (#236BF4)
    700: 'hsl(217, 83%, 48%)',
    800: 'hsl(216, 77%, 40%)',
    900: 'hsl(215, 70%, 33%)',
    950: 'hsl(213, 100%, 18%)', // brand
    DEFAULT: '#236BF4'
  },
  purple: {
    50: 'hsl(248, 73%, 97%)', // brand
    100: 'hsl(253, 70%, 94%)', // brand
    // 150: 'hsl(249, 77%, 92%)', // brand
    200: 'hsl(249, 84%, 87%)', //brand
    300: 'hsl(248, 92%, 82%)',
    400: 'hsl(242, 92%, 74%)',
    500: 'hsl(247, 87%, 64%)', // default (#6452F3)
    600: 'hsl(248, 78%, 59%)',
    700: 'hsl(250, 60%, 51%)',
    800: 'hsl(249, 51%, 47%)', // brand
    900: 'hsl(250, 50%, 34%)',
    950: 'hsl(252, 49%, 20%)',
    DEFAULT: '#6452F3'
  },
  turquoise: {
    50: 'hsl(169, 80%, 96%)', // brand
    // 75: 'hsl(171, 77%, 92%)', // brand
    100: 'hsl(171, 74%, 88%)', // brand
    200: 'hsl(170, 80%, 80%)', // brand
    300: 'hsl(170, 79%, 64%)', // default (#5CECD3)
    400: 'hsl(172, 73%, 50%)',
    500: 'hsl(173, 82%, 40%)',
    600: 'hsl(174, 86%, 32%)',
    700: 'hsl(174, 79%, 26%)',
    800: 'hsl(172, 71%, 24%)', // brand
    900: 'hsl(172, 71%, 18%)',
    950: 'hsl(177, 82%, 10%)',
    DEFAULT: '#5CECD3'
  },
  gray: {
    '50': 'hsl(180, 23%, 97%)', //brand white-gray, revised with tiny bit of blue
    '100': 'hsl(200, 22%, 92%)', // brand gray
    '200': 'hsl(200, 20%, 84%)',
    '300': 'hsl(198, 15%, 77%)', // brand silver
    '400': 'hsl(197, 9%, 55%)',
    '500': 'hsl(200, 12%, 43%)',
    '600': 'hsl(197, 15%, 36%)',
    '700': 'hsl(199, 14%, 31%)',
    '800': 'hsl(199, 16%, 27%)',
    '900': 'hsl(201, 21%, 21%)', // brand metal
    '950': 'hsl(204, 21%, 15%)',
    '1000': 'hsl(204, 21%, 1%)', // brand black revised with tiny bit of blue
    DEFAULT: 'hsl(200, 22%, 92%)' // brand gray
  },
  black: 'hsl(204, 21%, 1%)',
  // metal: '#2b3a42',
  silver: '#bbc7cc',
  // gray: '#E6ECEF',
  'white-gray': 'hsl(204, 10%, 98%)',
  white: '#FFFFFF',
  text: {
    DEFAULT: '#000000',
    'inactive': '#737373',
  }
}
